export default __webpack_public_path__ + "static/media/redblock.e89f60ba.webp";